import { Box, CircularProgress } from '@mui/material'
import React from 'react'

function Loader() {
    return (
        <div className='w-full text-center'>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center', // Centers horizontally
                    alignItems: 'center',     // Centers vertically
                    height: '100%',           // Ensure the container has height
                    minHeight: '200px'        // Or set a specific minimum height
                }}
            >
                <CircularProgress />
            </Box>
        </div>
    )
}

export default Loader